<h1 class="txt-section">Aviso de privacidad</h1>
<div class="CExpandir">
    <iframe id="iframeTuf" class="CExpandir" [src]="url" frameBorder="0"></iframe>
</div>